import { takeEvery, fork, put, all, call } from "redux-saga/effects";

// Groups Redux States
import {
  GET_GROUPS,
  CREATE_GROUPS,
  GET_GROUP,
  EDIT_GROUP,
  DELETE_GROUP,
} from "./actionTypes";
import {
  loadGroups,
  apiError,
  createdGroup,
  setGroup,
  editGroupSuccess,
  deleteGroupSuccess,
} from "./actions";
//Include Both Helper File with needed methods
import axios from "axios";

function* getGroups({ payload: { page, qnt, name, isForm } }) {
  try {
    const response = yield call(
      axios.get,
      `/group?${
        (page ? `page=${page}` : "") +
        (qnt ? `&qtd=${qnt}` : "") +
        (name ? `&name=${name}` : "") +
        (isForm ? `&form=${isForm}` : "")
      }`
    );
    if (
      (response.status >= 200 || response.status <= 299) &&
      response.data &&
      response.data.data
    ) {
      yield put(loadGroups(response.data.data, qnt));
    } else throw response.data;
  } catch (error) {
    let message;
    if (error.response && error.response.status) {
      //TODO: Incluir os tratamento necessário para apresentar os erros corretos
      switch (error.response.status) {
        case 401:
          message = "Your session has expired";
          break;
        case 500:
          message =
            "Sorry! something went wrong, please contact our support team";
          break;
        default:
          if (error.response.data && error.response.data.message)
            message = error.response.data.message;
          else message = error.message;
          break;
      }
    }
    yield put(apiError(message));
  }
}
function* createGroup({ payload: { newGroupValues } }) {
  try {
    const response = yield call(axios.post, "/group", newGroupValues.groups);
    if (
      (response.status >= 200 || response.status <= 299) &&
      response.data &&
      response.data.data
    ) {
      let message = response.data.message;
      yield put(createdGroup(newGroupValues, message));
    } else {
      throw response.data;
    }
  } catch (error) {
    let message;
    if (error.response && error.response.status) {
      //TODO: Incluir os tratamento necessário para apresentar os erros corretos
      switch (error.response.status) {
        case 401:
          message = "Your session has expired";
          break;
        case 404:
          message = "Sorry! the page you are looking for could not be found";
          break;
        case 500:
          message =
            "Sorry! something went wrong, please contact our support team";
          break;
        default:
          if (error.response.data && error.response.data.message)
            message = error.response.data.message;
          else message = error.message;
          break;
      }
    }
    yield put(apiError(message));
  }
}
function* getGroup({ payload: { idGroup, isForm } }) {
  try {
    const response = yield call(
      axios.get,
      `/group?${
        (idGroup ? `id=${idGroup}` : "") + (isForm ? `&form=${isForm}` : "")
      }`,
      {}
    );
    if (
      (response.status >= 200 || response.status <= 299) &&
      response.data
    ) {
      yield put(setGroup(response.data));
    } else throw response.data;
  } catch (error) {
    let message;
    if (error.response && error.response.status) {
      //TODO: Incluir os tratamento necessário para apresentar os erros corretos
      switch (error.response.status) {
        case 400:
          message = "Invalid data";
          break;
        case 401:
          message = "Your session has expired";
          break;
        case 404:
          message = "Sorry! the page you are looking for could not be found";
          break;
        case 500:
          message =
            "Sorry! something went wrong, please contact our support team";
          break;
        default:
          if (error.response.data && error.response.data.message)
            message = error.response.data.message;
          else message = error.message;
          break;
      }
    }
    yield put(apiError(message));
  }
}
function* editGroup({ payload: { idGroup, newGroupValues } }) {
  try {
    const response = yield call(
      axios.patch,
      `/group${idGroup ? `?id=${idGroup}` : ""}`,
      newGroupValues.groups
    );
    if ((response.status >= 200 || response.status <= 299) && response.data) {
      let message = response.data.message;
      yield put(editGroupSuccess(newGroupValues, message));
    } else throw response.data;
  } catch (error) {
    let message;
    if (error.response && error.response.status) {
      //TODO: Incluir os tratamento necessário para apresentar os erros corretos
      switch (error.response.status) {
        case 401:
          message = "Your session has expired";
          break;
        case 404:
          message = "Sorry! the page you are looking for could not be found";
          break;
        case 500:
          message =
            "Sorry! something went wrong, please contact our support team";
          break;
        default:
          if (error.response.data && error.response.data.message)
            message = error.response.data.message;
          else message = error.message;
          break;
      }
    }
    yield put(apiError(message));
  }
}
function* deleteGroup({ payload: { idGroup } }) {
  try {
    const response = yield call(
      axios.delete,
      `/group${idGroup ? `?id=${idGroup}` : ""}`
    );
    if (response.status >= 200 || response.status <= 299) {
      let message = response.data.message ? response.data.message : "";
      yield put(deleteGroupSuccess(idGroup, message));
    } else {
      throw response.data;
    }
  } catch (error) {
    let message;
    if (error.response && error.response.status) {
      switch (error.response.status) {
        case 401:
          message = "Invalid credentials";
          break;
        case 404:
          message = "Group not found";
          break;
        case 500:
          message =
            "Sorry! something went wrong, please contact our support team";
          break;
        default:
          if (error.response.data && error.response.data.message)
            message = error.response.data.message;
          else message = error.message;
          break;
      }
    }
    yield put(apiError(message));
  }
}
export function* watchGroup() {
  yield takeEvery(GET_GROUPS, getGroups);
}
export function* watchCreateGroup() {
  yield takeEvery(CREATE_GROUPS, createGroup);
}
export function* watchGetGroup() {
  yield takeEvery(GET_GROUP, getGroup);
}
export function* watchEditGroup() {
  yield takeEvery(EDIT_GROUP, editGroup);
}
export function* watchDeleteGroup() {
  yield takeEvery(DELETE_GROUP, deleteGroup);
}
function* authSaga() {
  yield all([
    fork(watchGroup),
    fork(watchCreateGroup),
    fork(watchGetGroup),
    fork(watchEditGroup),
    fork(watchDeleteGroup),
  ]);
}

export default authSaga;
